module.exports = __webpack_public_path__ + "img/AI.263d8cfa.png";